import {GAME_EVENTS} from "../../game/gameEvents";
import events from "../../events/EventsObservable";

export let madnes_adapter = null;

/**
 * @type {SystemConfig}
 */
export let systemConfig = null;

/**
 *
 * @type {MadnesCommander}
 */
export let commander = null;

/**
 * @type {MadnesGame}
 */
export let game = null;

/**
 * @type {GameFreespins}
 */
export let freespins = null;

/**
 * @type {Wallet}
 */
export let wallet = null;

/**
 *
 * @type {StatesManager}
 */
export let states = null;

/**
 *
 * @type {Fullscreen}
 */
export let screen = null;

export let in_free_spins = false;
export let in_free_spins_pos = 0;
export let in_free_spins_total = 0;

export let server_config = null;
export let behavior_config = null;
export let server_result = null;

export let rotated = false;

export let picture_convert = [];

export let quality = -1;
export let ico_wi = 100;
export let ico_he = 100;

export let big_win;
export let mega_win;
export let super_win;

export let config_load_symbols = true;
export let disable_load_blur = false;

export let reels_lenghts = [];
export let reels_pos = [];

export const alldone = [];

export let wi = 1280;
export let he = 720;

export let wi_scale = 1;
export let he_scale = 1;
export let multi = 1;

export const madnes_objects = {};
export const sprite_sizes = [];

export let round_running = false;

export const fps = 30;

export let forcestopnow = false;
export let forcestop_enable = true;

export let autospin_force_enabled = false;
export let autospin_force = false;

export let inmoneyadd = false;
export let inbigwin = false;
export let inwincount = false;
export let inanim = false;

export let win_anim_skip_click = false;

export const to_load_audio_madnes = {};
to_load_audio_madnes['coins_loop'] = 'framework/assets/audio/jackpot_Coins.ogg';
//to_load_audio_madnes['start_rotate'] = 'framework/assets/audio/ui/ui_btn_generic.ogg';
to_load_audio_madnes['button_click'] = 'framework/assets/audio/ui_Btn_Generic.ogg';
to_load_audio_madnes['remittance_A'] = 'framework/assets/audio/ui_Counter.ogg';
to_load_audio_madnes['remittance_B'] = 'framework/assets/audio/ui_Counter_Stop.ogg';

export function set_madnes_adapter(adapter) {
    madnes_adapter = adapter;
}

export function set_systemConfig(cfg) {
    systemConfig = cfg;
}

export function set_commander(cmd) {
    commander = cmd;
}

export function set_game(g) {
    game = g;
    freespins = game.freespins;
}

export function set_wallet(w) {
    wallet = w;
}

export function set_states(s) {
    states = s;
}

/**
 *
 * @param {Fullscreen} scr
 */
export function set_screen(scr) {
    screen = scr;
}

/**
 * @param {*} cfg
 */
export function set_server_config(cfg) {
    server_config = cfg;
}

export function set_behavior_config(cfg) {
    behavior_config = cfg;
}

export function set_rotated(bool) {
    rotated = bool;
}

export function set_server_result(res) {
    server_result = res;
}

export function set_disable_load_blur(val) {
    disable_load_blur = val;
}

export function set_round_running(bool) {
    round_running = bool;
}

export function set_in_free_spins(bool) {
    in_free_spins = bool;
}

export function set_in_free_spins_pos(pos) {
    in_free_spins_pos = pos;
}

export function set_in_free_spins_total(val) {
    in_free_spins_total = val;
}

export function inc_in_free_spins_total(pos) {
    in_free_spins_total++;
}

export function set_picture_convert(server_config) {
    for (let i in server_config.logic.symbols) {
        let symbol = server_config.logic.symbols[i];
        picture_convert[symbol.index] = symbol.name;
    }
}

/**
 * @param {number} q
 */
export function set_quality(q) {
    quality = q;
}

/**
 *
 * @param {number} q
 */
export function set_ico_wi(wi) {
    ico_wi = wi;
}

/**
 *
 * @param {number} he
 */
export function set_ico_he(he) {
    ico_he = he;
}

export function set_ico_size(w, h) {
    ico_wi = w;
    ico_he = h;
}

/**
 * @param bool
 */
export function set_config_load_symbols(bool) {
    config_load_symbols = bool;
}

export function set_big_win(bw) {
    big_win = bw;
}

export function set_mega_win(mw) {
    mega_win = mw;
}

export function set_super_win(sw) {
    super_win = sw;
}

export function set_forcestopnow(bool) {
    forcestopnow = bool;
}

export function set_forcestop_enable(bool) {
    forcestop_enable = bool;
}

export function set_inmoneyadd(bool) {
    inmoneyadd = bool;
}

export function set_inbigwin(bool) {
    inbigwin = bool;
    if (!!bool) {
        events.dispatch(GAME_EVENTS.GAME_BIGWIN);
    }
}

export function set_inwincount(bool) {
    inwincount = bool;
}

export function set_inanim(bool) {
    inanim = bool;
}

export function set_autospin_force_enabled(bool) {
    autospin_force_enabled = bool;
}

export function set_autospin_force(bool) {
    autospin_force = bool;
}

export function set_win_anim_skip_click(bool) {
    win_anim_skip_click = bool;
}